import { Pipe, PipeTransform } from '@angular/core';
import { ADDRESS_TEMPLATES, AddressInput } from '../../config/address-format.config';

@Pipe({
  name: 'addressFormat',
  standalone: true,
})
export class AddressFormatPipe implements PipeTransform {
  transform(addr: AddressInput, mode: 'multi' | 'single' = 'multi'): string {
    if (!addr) return '';

    const code = addr.country_code?.toUpperCase();
    const formatter = ADDRESS_TEMPLATES[code] || ADDRESS_TEMPLATES['DE']; // DE fallback

    const { line1, line2, line3, line4, line5 } = formatter(addr);

    const parts = [line1, line2, line3, line4, line5].filter(Boolean);

    return mode === 'multi'
      ? parts.join('\n')
      : parts.join(', ');
  }
}
